import { defaultSelectedItem } from "./state";
// HALLAZGOS
export function setListarHallazgos(state, hallazgos) {
    state.hallazgos = hallazgos
}

export function setFiltroEmpresaHallazgo(state, buscar) {
    state.filtro.id_empresa = buscar
}

export function setAccion(state, accion) {
    state.accion = accion;
}

export function accionError(state) {
    state.error = true
}
